/* eslint-disable @typescript-eslint/no-explicit-any */
import { ROLES } from '@config/constants/roles';
import { apiClient } from '@lib/api-client';
import { useAuthorization } from '@lib/authorization';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from 'shared/interfaces/site';

export const getBrands = (): Promise<ApiResponse> => {
	return apiClient.get('/brands', {
		params: {
			pageSize: 100,
			sort: 'name',
		},
	});
};

export const useBrands = () => {
	const { checkRole } = useAuthorization();
	const { data, isFetching, isFetched, isPending } =
		useQuery({
			queryKey: ['brands'],
			queryFn: () => {
				return getBrands();
			},
			enabled: !checkRole([
				ROLES.PRODUCER_ADMIN,
				ROLES.PRODUCER_STAFF,
			]),
		});

	const updateList = (brands: any) =>
		brands && Array.isArray(brands)
			? brands.reduce((acc: any, currentItem: any) => {
					const modifiedItem = {
						...currentItem,
					};
					acc.push(modifiedItem);

					return acc;
				}, [])
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		isFetching,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
		isPending,
	};
};
